import React, { useRef, useEffect, useState } from "react";

import EessAutocomplete from "../../../components/autocomplete/EessAutocomplete";
import ProductoAutocomplete from "../../../components/autocomplete/ProductoAutocomplete";
import LiquidacionEjecucionAutocomplete from "../../../components/autocomplete/LiquidacionEjecucionAutocomplete";

export default function FiltroLiquidacionDeEess({
  initialFilters = {},
  onClose = () => {},
  onSubmit = () => {},
}) {
  const filtroRef = useRef(null);

  // =====================================================
  // ESTADO (rehidratable – UI)
  // =====================================================
  const [eess, setEess] = useState(initialFilters.eess ?? null);
  const [producto, setProducto] = useState(initialFilters.producto ?? null);
  const [liquidacionEjecucion, setLiquidacionEjecucion] = useState(
    initialFilters.liquidacionEjecucion ?? null
  );

  // =====================================================
  // ESTADO (numéricos – legacy)
  // =====================================================
  const [valorTotal, setValorTotal] = useState(
    initialFilters.valorTotal ?? ""
  );
  const [valorTotalDescEess, setValorTotalDescEess] = useState(
    initialFilters.valorTotalDescEess ?? ""
  );
  const [valorTotalBonif, setValorTotalBonif] = useState(
    initialFilters.valorTotalBonif ?? ""
  );
  const [qnProducto, setQnProducto] = useState(
    initialFilters.qnProducto ?? ""
  );
  const [valorPrecio, setValorPrecio] = useState(
    initialFilters.valorPrecio ?? ""
  );
  const [valorIva, setValorIva] = useState(
    initialFilters.valorIva ?? ""
  );

  // =====================================================
  // CERRAR CLICK FUERA / ESC
  // =====================================================
  useEffect(() => {
    const outside = (e) => {
      if (filtroRef.current && !filtroRef.current.contains(e.target)) {
        onClose();
      }
    };

    const esc = (e) => e.key === "Escape" && onClose();

    document.addEventListener("mousedown", outside);
    document.addEventListener("keydown", esc);
    return () => {
      document.removeEventListener("mousedown", outside);
      document.removeEventListener("keydown", esc);
    };
  }, [onClose]);

  // =====================================================
  // SUBMIT
  // =====================================================
  const handleSubmit = (e) => {
    e.preventDefault();

    const toNull = (v) =>
      String(v ?? "").trim() === "" ? null : String(v).trim();

    onSubmit({
      // UI (rehidratable)
      eess,
      producto,
      liquidacionEjecucion,

      // backend (IDs)
      eessId: eess?.id ?? null,
      productoId: producto?.id ?? null,
      liquidacionEjecucionId: liquidacionEjecucion?.id ?? null,

      // backend (numéricos legacy)
      valorTotal: toNull(valorTotal),
      valorTotalDescEess: toNull(valorTotalDescEess),
      valorTotalBonif: toNull(valorTotalBonif),
      qnProducto: toNull(qnProducto),
      valorPrecio: toNull(valorPrecio),
      valorIva: toNull(valorIva),
    });
  };

  // =====================================================
  // RENDER
  // =====================================================
  return (
    <div className="drawer-backdrop">
      <div
        ref={filtroRef}
        onClick={(e) => e.stopPropagation()}
        className="drawer-panel overflow-auto"
      >
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-title">Filtros</h2>
          <button onClick={onClose} className="btn-cancel" title="Cerrar">
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">

          {/* EESS */}
          <div>
            <label className="form-label-fil">EESS</label>
            <EessAutocomplete value={eess} onChange={setEess} />
          </div>

          {/* Producto */}
          <div>
            <label className="form-label-fil">Producto</label>
            <ProductoAutocomplete value={producto} onChange={setProducto} />
          </div>

          {/* Liquidación Ejecución */}
          <div>
            <label className="form-label-fil">Liquidación Ejecución</label>
            <LiquidacionEjecucionAutocomplete
              value={liquidacionEjecucion}
              onChange={setLiquidacionEjecucion}
            />
          </div>

          {/* Numéricos legacy */}
          <div>
            <label className="form-label-fil">Total</label>
            <input
              className="input"
              value={valorTotal}
              onChange={(e) => setValorTotal(e.target.value)}
            />
          </div>

          <div>
            <label className="form-label-fil">Total Desc. EE.SS.</label>
            <input
              className="input"
              value={valorTotalDescEess}
              onChange={(e) => setValorTotalDescEess(e.target.value)}
            />
          </div>

          <div>
            <label className="form-label-fil">Total Bonificación</label>
            <input
              className="input"
              value={valorTotalBonif}
              onChange={(e) => setValorTotalBonif(e.target.value)}
            />
          </div>

          <div>
            <label className="form-label-fil">Cantidad</label>
            <input
              className="input"
              value={qnProducto}
              onChange={(e) => setQnProducto(e.target.value)}
            />
          </div>

          <div>
            <label className="form-label-fil">Precio</label>
            <input
              className="input"
              value={valorPrecio}
              onChange={(e) => setValorPrecio(e.target.value)}
            />
          </div>

          <div>
            <label className="form-label-fil">Valor IVA</label>
            <input
              className="input"
              value={valorIva}
              onChange={(e) => setValorIva(e.target.value)}
            />
          </div>

          <div className="text-right">
            <button type="submit" className="btn">
              Aplicar filtros
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
